export default __webpack_public_path__ + "static/media/cyber-woman.00e117d0.jpg";